import Input from "../../../../components/Input/Input"
import Button from "../../../../components/Button/Button"
import {
  smsBankAccount,
} from '../../../../features/contacts/contacts'
import { showSnackBar } from "../../../../components/Snackbar/Snackbar"
import { useDispatch, useSelector } from "react-redux"
import { selectFeatureFlag } from '../../../../features/featureFlags/selectors'
import { REQUEST_ERRORS_SCREENS, REQUEST_ERRORS_SMS } from '../../../../constants/requestErrorFlags'
import { createBankAccountLink } from "../../../../features/bankAccountLink/bankAccountLink"
import { useMyContextLoading } from "../../../../components/LoadingContextProvider/LoadingContextProvider"
import { useState } from "react"
import { editContactById } from '../../../../features/customer/customerSlice'
import { acceptsAch } from '../../../../constants/paymentMethods'

export const SendText = ({ userId, isBillingAccount, isSignedMainDoc, primaryPhone, userRole, lsaTemplateType, signingBlocked, blockedHint, acceptedPaymentMethods, stopOnSendError = false }) => {

  const [phoneValue, setPhoneValue] = useState(primaryPhone)

  const { triggerLoading } = useMyContextLoading()

  const cardOnly = !acceptsAch(acceptedPaymentMethods)
  const clientProvides = cardOnly ? 'payment details' : 'bank information'
  const repEnters = cardOnly ? 'payment details' : 'bank details'
  const clientAdds = cardOnly ? 'payment details' : 'bank account'

  const dispatch = useDispatch()
  const screensOn = useSelector(selectFeatureFlag(REQUEST_ERRORS_SCREENS))
  const smsOn = useSelector(selectFeatureFlag(REQUEST_ERRORS_SMS))

  const handleSendText = async () => {
    const response = await dispatch(smsBankAccount({ phoneNumber: phoneValue, userId, lsaTemplateType }))
    if ((screensOn || smsOn || stopOnSendError) && response.error) {
      showSnackBar("error", typeof response.payload === 'string' ? response.payload : "Something went wrong")
      triggerLoading(false)
      return
    }
    if (response.error) {
      showSnackBar("error", "Something went wrong")
    }
    triggerLoading(false)
    showSnackBar("success", "Text Message successfully sent")

  }

  const handleCreateLink = async () => {
    triggerLoading(true)
    const response = await dispatch(createBankAccountLink(userId))
    if (response.error) {
      showSnackBar("error", "Something went wrong")
      triggerLoading(false)
    } else {
      await handleSendText()
    }
  }

  const updateUserPhone = async () => {
    try {
      const response = await dispatch(editContactById({
        userId,
        userData: { primaryPhone: phoneValue }
      }))
      if (response.error) {
      } else {
        showSnackBar("success", "Contact successfully updated")
      }
    } catch (error) {
    }
  }

  const handlePhoneInput = async (phoneValue) => {
    const newNumber = phoneValue?.replace(/\D/g, "")
    setPhoneValue(newNumber)
  }

  return (
    <>
      <div>
        <div className="bg-background p-6 rounded-2xl">
          {
            (userRole === 'customer' || userRole === 'user') ?
              `You can either send the URL via text so the customer can provide their ${clientProvides} and confirm the
          agreement, or you can enter the ${repEnters} manually. Once the payment method is set up, you’ll be able to
          upload the LSA document manually.`
              : `The last step is to send the customer a url to add their ${clientAdds} and confirm the agreement. Send the url
          via text below:`
          }
        </div>
        <div className="pt-[24px]">
          <Input
            disabled={isSignedMainDoc}
            type="phone-number"
            value={phoneValue}
            onChange={(e) => handlePhoneInput(e.target.value)}
            placeholder="Enter Primary Phone Number"
            label="Confirm phone number"
          />
        </div>
      </div>
      {(
        <div className="mt-6 mb-6 flex flex-col items-end space-y-2">
          {signingBlocked && !isSignedMainDoc && (
            <div className="text-sm text-text-secondary">
              {blockedHint || 'No enrolled debts — complete Credit Select first.'}
            </div>
          )}
          <Button
            disabled={isSignedMainDoc || signingBlocked}
            width="min-w-[156px]"
            onClick={() => {
              isBillingAccount ? handleSendText() : handleCreateLink()
              updateUserPhone()
            }}
          >
            {isBillingAccount ? "Resend text message" : "Send text message"}
          </Button>
        </div>
      )
      }
    </>
  )
}
